import { listingsAPI } from '../api/client'

type PhoneModelRow = Awaited<ReturnType<typeof listingsAPI.getPhoneModels>>['data'][number]

let cached: PhoneModelRow[] | null = null
let inflight: Promise<PhoneModelRow[]> | null = null

/** Reuse the phone catalog across sell remounts — avoids re-fetching ~9k models on navigation. */
export function fetchPhoneModelsCached(): Promise<PhoneModelRow[]> {
  if (cached) return Promise.resolve(cached)
  if (!inflight) {
    inflight = listingsAPI
      .getPhoneModels()
      .then((res) => {
        cached = res.data
        return res.data
      })
      .catch((err) => {
        inflight = null
        throw err
      })
  }
  return inflight
}

/** Force a fresh catalog fetch (e.g. after a failed load). */
export function invalidatePhoneModelsCache(): void {
  cached = null
  inflight = null
}
